export default "__VITE_ASSET__tM0MuM_f__"